var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_x5F_card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1801 449H247c-67 0-123 55-123 123v905c0 68 56 123 123 123h1554c68 0 123-55 123-123V572c0-68-55-123-123-123zm-7 1021H254V579h1540v891z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M703 1024a316 316 0 0 0-317 317h633c0-175-141-317-316-317z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 703,
    cy: 857,
    r: 157
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1600 1212h-253c-35 0-63 28-63 62 0 35 28 63 63 63h253a63 63 0 1 0 0-125zM1212 1080h388c34 0 63-28 63-62 0-35-29-63-63-63h-388a63 63 0 1 0 0 125zM1212 824h388a63 63 0 1 0 0-125h-388c-34 0-62 28-62 62 0 35 28 63 62 63z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdsIcon);
export default __webpack_public_path__ + "static/media/IDS_icon.ccf8e9f04239823846b97de0320b948c.svg";
export { ForwardRef as ReactComponent };